export enum ScheduleTreatmentPeriod {
  MORNING = 'MORNING',
  AFTERNOON = 'AFTERNOON',
  NIGHT = 'NIGHT'
}

export enum ScheduleTreatmentType {
  ORAL = 'ORAL',
  INJECTABLE = 'INJECTABLE'
}

export interface Treatment {
  date: Date;
  period: ScheduleTreatmentPeriod;
  treatmentType: ScheduleTreatmentType;
  description: string;
}

export interface ScheduleTreatment {
  date: Date;
  treatments: Treatment[];
}
